export const faqData = [
  {
    question: "TBM健康美容研究所はどのような事業を行っていますか？",
    answer:
      "教材・出版、新製品化、健康事業、サロン経営コンサルティング、スクール・セミナー、総合美容検定、グローバルプロジェクトなど、健康・美容トレンドを多角的にプロデュースする総合研究所です。",
  },
  {
    question: "高崎ビューティモード専門学校との連携内容を教えてください。",
    answer:
      "学校法人有坂中央学園が運営する高崎ビューティモード専門学校と密接に連携し、美容業界の教育・人材育成において協力体制を築いています。最新の美容理論と実践的な技術教育を融合し、次世代の美容プロフェッショナルを共に育成しています。",
  },
  {
    question: "総合美容検定とは何ですか？",
    answer:
      "美容に関する知識・技術を総合的に評価する検定制度です。美容業界で働く方やこれから美容業界を目指す方のスキル向上を支援し、キャリア形成をサポートします。",
  },
  {
    question: "サロン経営コンサルティングの内容を教えてください。",
    answer:
      "美容サロンの開業支援から既存サロンの経営改善まで、集客・人材育成・メニュー設計など、経営課題に応じたコンサルティングを提供しています。",
  },
  {
    question: "セミナーやスクールへの参加方法を教えてください。",
    answer:
      "お問い合わせフォームまたはお電話（027-310-2220）にてお気軽にご連絡ください。開催予定や受講内容についてご案内いたします。",
  },
  {
    question: "営業時間と所在地を教えてください。",
    answer:
      "営業時間は平日 9:00〜18:00（土日祝休み）です。所在地は〒370-0841 群馬県高崎市栄町13-1になります。",
  },
];